import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { Chip } from "@mui/material";
import {
  DataGrid,
  GridColumnSettings,
  timestampValueGetter,
} from "common";
import IntegrationHistoryForm from "./IntegrationHistoryForm";
import useIntegrationHistoryList from "./useIntegrationHistoryList";
export default function IntegrationHistoryList() {
  const grid = useIntegrationHistoryList();
  let columnSettings: GridColumnSettings = {
    begin_at: { valueFormatter: timestampValueGetter },
    end_at: { valueFormatter: timestampValueGetter },
    success: {
      renderCell: params => {
        return (
          <Chip
            size="small"
            color={params.row.success ? "success" : "error"}
            label={params.row.success ? "Success" : "Error"}
            icon={
              params.row.success ? <TaskAltIcon /> : <ReportGmailerrorredIcon />
            }
          />
        );
      },
    },
  };

  return (
    <DataGrid
      {...grid}
      renderModalForm={props => <IntegrationHistoryForm {...props} />}
      columnSettings={columnSettings}
      headerItems={["search", "refresh"]}
      canDelete
      canView
    />
  );
}
